import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CustomformComponent } from '../../../../customform/customform.component';

export interface IPageComponentCustomformData {
    form_identifier?: string;
    newsletter_source?: string;
}

@Component({
    selector: 'page-component-customform',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CustomformComponent],
    template: ` <customform [identifier]="component.form_identifier" [source]="component.newsletter_source"></customform>`
})
@ICmsComponent<PageComponentCustomformComponent>({
    id: 'customform',
    name: 'Custom Form',
    isAdvanced: true,
    hidePreview: true,
    description: 'Custom form from Landofcoders Magento plugin',
    tags: ['form', 'custom'],
    fields: [
        {
            key: 'form_identifier',
            type: NICmsContentField.EFieldType.text,
            title: 'Form Identifier'
        },
        {
            key: 'newsletter_source',
            type: NICmsContentField.EFieldType.text,
            title: 'Newsletter Source'
        }
    ]
})
export class PageComponentCustomformComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentCustomformData;
}
